import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import SummaryTab from "@/components/SummaryTab";
import ObservationsTab from "@/components/ObservationsTab";
import AlertsTab from "@/components/AlertsTab";
import CollaboratorsTab from "@/components/CollaboratorsTab";
import BottomNav from "@/components/BottomNav";
import PushNotification from "@/components/PushNotification";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MainApp() {
  const [activeTab, setActiveTab] = useState("summary");
  const [showPush, setShowPush] = useState(false);
  const prevTabRef = useRef("summary");
  const { user, child, setChild } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) { navigate("/", { replace: true }); return; }
    if (!child) { navigate("/onboarding", { replace: true }); return; }
  }, [user, child, navigate]);

  useEffect(() => {
    if (child && !child.clips_ingested) {
      axios.post(`${API}/children/${child.id}/ingest-clips`)
        .then(() => setChild((prev) => prev ? { ...prev, clips_ingested: true } : prev))
        .catch(() => {});
    }
  }, [child, setChild]);

  // Fire push notification whenever user switches INTO alerts tab
  useEffect(() => {
    if (activeTab === "alerts" && prevTabRef.current !== "alerts") {
      setShowPush(true);
    }
    prevTabRef.current = activeTab;
  }, [activeTab]);

  if (!child) return null;

  return (
    <div className="min-h-screen bg-[#FAFAF7]" data-testid="main-app">
      <PushNotification
        show={showPush}
        onDismiss={() => setShowPush(false)}
        title="Aavyaa just removed her glasses"
        body="Detected during playroom activity · Tap to view"
      />
      <div className="max-w-lg mx-auto pb-24">
        {activeTab === "summary" && <SummaryTab />}
        {activeTab === "observations" && <ObservationsTab />}
        {activeTab === "alerts" && <AlertsTab />}
        {activeTab === "collaborators" && <CollaboratorsTab />}
      </div>
      <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}
